import * as React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, TextField } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { ConfirmBoxWrapper } from './ConfirmBoxStyled';
import { Constant } from './Constant';
const  ConfirmBox=({ show,title,heading,imgsrc,handleConfirm,handleClose  }) =>{
  return (
    <div>
      <ConfirmBoxWrapper
        open={show}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
        {title}
        </DialogTitle>
        <DialogContent>
           
            <DialogContentText id="alert-dialog-description" className="customDialog">
             <div><img src={imgsrc} alt="img" /></div> 
                <div>{heading}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className='dialogbutton'>
              <Button variant="contained" className='confirmButton' onClick={handleConfirm}> {Constant.OK}</Button>
        </DialogActions> 
      </ConfirmBoxWrapper>
    </div>
  );
};

export default ConfirmBox;
